import script from "./TravelInfoVIew.vue?vue&type=script&setup=true&lang=ts"
export * from "./TravelInfoVIew.vue?vue&type=script&setup=true&lang=ts"

import "./TravelInfoVIew.vue?vue&type=style&index=0&id=ebf99ca8&lang=css&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d0e91f904bb1d11c0b68168201cc497f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebf99ca8"]])

export default __exports__